import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5162e203"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_2 = { class: "barcode-scanner" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-1 items-center overflow-scroll space-x-xs mx-auto",
  style: {"width":"250px"}
}
const _hoisted_4 = { key: 1 }

import { ref, onMounted, onBeforeUnmount } from "vue";
import {
  BrowserMultiFormatReader,
  BarcodeFormat,
  DecodeHintType,
} from "@zxing/library";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { findMedicationWithGtin } from "@/helpers/requestHelpers/medicationRequests";
import UButton from "@/components/UButton.vue";
import { useNotificationStore } from "@/store/notificationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'BarcodeScanner',
  props: {
    careProviderGroupId: {}
  },
  emits: ["barcode-scanned"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const videoStream = ref<MediaStream | null>(null);
const hints = new Map();
const formats = [BarcodeFormat.EAN_13];
const devices = ref<InputDeviceInfo[]>([]); // eslint-disable-line
const currentDeviceId = ref<string>("");

hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
const loading = ref<boolean>(false);
const codeReader = new BrowserMultiFormatReader(hints);
const video = ref<HTMLVideoElement | null>(null);
const emits = __emit;

const initScanner = async (newPreferId?: string) => {
  if (!video.value) return;
  if (codeReader && codeReader.reset) {
    codeReader.stopAsyncDecode();
    codeReader.reset();
  }

  try {
    const preferId = newPreferId ?? localStorage.getItem("preferCam");

    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      devices.value = (await navigator.mediaDevices.enumerateDevices())
        .filter((device) => device.kind == "videoinput")
        .sort((a, b) => (a.label > b.label ? -1 : 1));
    }

    currentDeviceId.value = preferId ?? "";
    localStorage.setItem("preferCam", preferId ?? "");

    const videoWidth = 300;
    const videoHeight = 50;

    video.value.setAttribute("width", videoWidth.toString());
    video.value.setAttribute("height", videoHeight.toString());

    codeReader.decodeFromVideoDevice(
      preferId,
      video.value,
      async (result, error) => {
        if (result) {
          codeReader.reset();

          videoStream.value?.getTracks().forEach((track) => track.stop());

          const gtin = parseInt(result.getText());
          if (isNaN(gtin)) return;
          loading.value = true;
          const res = await findMedicationWithGtin(
            gtin,
            props.careProviderGroupId
          );
          loading.value = false;

          if (res.error !== null) {
            useNotificationStore().notifications.push({
              msg: "Es ist ein Fehler aufgetreten. Bitten versuchen Sie es erneut.",
              type: "danger",
            });
          }

          if (res.data === null && res.error === null) {
            useNotificationStore().notifications.push({
              msg: "Es konnte kein Medikament mit diesem Barcode gefunden werden.",
              type: "danger",
            });
          }

          emits("barcode-scanned", res.data);
        }
      }
    );
  } catch (error) {
    if (`${error}`.toLocaleLowerCase().includes("Permission denied")) {
      useNotificationStore().notifications.push({
        msg: `Fehler - Es kann nicht auf die Kamera zugegriffen werden. Bitte Berechtigungen prüfen.`,
        type: "danger",
      });
    }
    if (videoStream.value) {
      videoStream.value.getTracks().forEach((track) => track.stop());
      codeReader.reset();
    }
    console.error("Error accessing camera:", error);
  }
};
const shortName = (name: string) => {
  return name;
};

onMounted(initScanner);

onBeforeUnmount(() => {
  codeReader.reset();
  if (videoStream.value) {
    videoStream.value.getTracks().forEach((track) => track.stop());
  }
});

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("video", {
            ref_key: "video",
            ref: video,
            autoplay: "",
            playsinline: ""
          }, null, 512)
        ]),
        (devices.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (device) => {
                return (_openBlock(), _createBlock(UButton, {
                  color: currentDeviceId.value == device.deviceId ? 'orange' : 'white',
                  onClick: ($event: any) => (initScanner(device.deviceId)),
                  key: device.deviceId,
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(shortName(device.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(LoadingSpinner)
      ]))
}
}

})